import { Route, RouteConfig } from 'vue-router';
import { WmsPageComposer } from '../components/page-composer/page-composer';
import { router } from './router';

export const CI_URL = 'central-interier';

export const CI_ROUTES: RouteConfig[] = [
	{
		path: '/page/ci-home',
		name: 'ci-home',
		meta: { ciRedirect: '/' },
		props: { pageUrl: 'ci-home' },
		component: WmsPageComposer
	},
	{
		path: '/page/ci-modern',
		name: 'ci-modern',
		alias: '/modern',
		meta: { ciRedirect: '/modern' },
		props: { pageUrl: 'ci-modern' },
		component: WmsPageComposer
	},
	{
		path: '/page/ci-design',
		name: 'ci-design',
		alias: '/design',
		meta: { ciRedirect: '/design' },
		props: { pageUrl: 'ci-design' },
		component: WmsPageComposer
	},
	{
		path: '/page/ci-prestige',
		name: 'ci-prestige',
		alias: '/prestige',
		meta: { ciRedirect: '/prestige' },
		props: { pageUrl: 'ci-prestige' },
		component: WmsPageComposer
	},
	{
		path: '/page/ci-classic',
		name: 'ci-classic',
		alias: '/classic',
		meta: { ciRedirect: '/classic' },
		props: { pageUrl: 'ci-classic' },
		component: WmsPageComposer
	},
	{
		path: '/page/ci-industrial',
		name: 'ci-industrial',
		alias: '/industrial',
		meta: { ciRedirect: '/industrial' },
		props: { pageUrl: 'ci-industrial' },
		component: WmsPageComposer
	},
	{
		path: '/page/ci-exclusive',
		name: 'ci-exclusive',
		alias: '/exclusive',
		meta: { ciRedirect: '/exclusive' },
		props: { pageUrl: 'ci-exclusive' },
		component: WmsPageComposer
	},
	{
		path: '/page/ci-proc-central-interier',
		name: 'ci-proc-central-interier',
		alias: '/proc-central-interier',
		meta: { ciRedirect: '/proc-central-interier' },
		props: { pageUrl: 'ci-proc-central-interier' },
		component: WmsPageComposer
	},
	{
		path: '/page/ci-kontakty',
		name: 'ci-kontakty',
		alias: '/kontakty',
		meta: { ciRedirect: '/kontakty' },
		props: { pageUrl: 'ci-kontakty' },
		component: WmsPageComposer
	}
	,
	{
		path: '/page/ci-showroom',
		name: 'ci-showroom',
		alias: '/showroom',
		meta: { ciRedirect: '/showroom' },
		props: { pageUrl: 'ci-showroom' },
		component: WmsPageComposer
	}
	,
	{
		path: '/page/ci-fotogalerie',
		name: 'ci-fotogalerie',
		alias: '/fotogalerie',
		meta: { ciRedirect: '/fotogalerie' },
		props: { pageUrl: 'ci-fotogalerie' },
		component: WmsPageComposer
	}
	,
	{
		path: '/page/ci-jak-postupovat',
		name: 'ci-jak-postupovat',
		alias: '/jak-postupovat',
		meta: { ciRedirect: '/jak-postupovat' },
		props: { pageUrl: 'ci-jak-postupovat' },
		component: WmsPageComposer
	}
];

export function ciGuard(to: Route, _from: Route, next: Function): boolean {
	if (window.location.href.indexOf(CI_URL) > -1 && to.meta.ciRedirect) {
		if (to.meta.ciRedirect !== to.fullPath) {
			next({ path: to.meta.ciRedirect, replace: true });
			return true;
		}
	}

	if (window.location.href.indexOf(CI_URL) === -1 && to.meta.ciRedirect) {
		next({ path: '/nenalezeno', replace: true });
		return true;
	}

	if (
		window.location.href.indexOf(CI_URL) > -1 &&
		to.fullPath !== '/' &&
		!to.meta.ciRedirect
	) {
		const { afterClick } = (router as any).meta;

		// send all other route requets as HTTP GET requests
		if (afterClick) {
			window.location.href = to.fullPath;
		} else {
			window.location.href = `https://www.central-group.cz/nenalezeno.html`;
		}

		return true;
	}

	return false;
}
